export const Layout = () => import('@/layout/index.vue')
import { getRouteRoles } from '@/utils/index'

/**
 * 标签印刷AI订单系统路由
 */
const routes = {
  path: '/channel',
  //redirect: 'noRedirect',
  component: Layout,
  meta: {
    icon: 'Document',
    title: '数据中心',
    roles: [],
    activeMenuTop: '/channel',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  },
  children: [
    {
      path: 'wecom',
      name: 'WeCom',
      component: () => import('@/views/channel/wecom/list.vue'),
      meta: {
        title: '企业微信',
        icon: 'User',
        roles: ['admin/channel.WeCom/list'],
        activeMenuTop: '/channel',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'miniprogram',
      name: 'MiniProgram',
      component: () => import('@/views/channel/miniprogram/index.vue'),
      meta: {
        title: '小程序',
        icon: 'Money',
        roles: ['admin/channel.MiniProgram/list'],
        activeMenuTop: '/channel',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'qq',
      name: 'QQ',
      component: () => import('@/views/channel/qq/index.vue'),
      meta: {
        title: 'QQ',
        icon: 'Connection',
        roles: ['admin/channel.QQ/list'],
        activeMenuTop: '/channel',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    }
  ]
}

routes.meta.roles = getRouteRoles(routes)

export default routes
